module.exports = __webpack_public_path__ + "img/IMG_7100.50d5317a.webp";